import { SwalService } from './../../../shared/services/swal.service';
import { LoginService } from './../../services/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-password-first-time',
  templateUrl: './password-first-time.component.html',
  styleUrls: ['./password-first-time.component.css', '../modalstyles.css'],
})
export class PasswordFirstTimeComponent implements OnInit {
  passwordForm: FormGroup;

  _sended: boolean;

  constructor(
    public modalRef: BsModalRef,
    private router: Router,
    private formbuilder: FormBuilder,
    private _login: LoginService,
    private _swal: SwalService
  ) {}

  ngOnInit() {
    this.initPasswordForm();
  }

  /**
   * Inicialización del formulario
   */
  initPasswordForm() {
    this.passwordForm = this.formbuilder.group(
      {
        password: [
          null,
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(190),
          ],
        ],
        password_confirmation: [null, Validators.required],
        correo: [
          sessionStorage.getItem('mail'),
          [Validators.required, Validators.email],
        ],
      },
      {
        validator: MustMatch('password', 'password_confirmation'),
      }
    );
  }

  /**
   * Getter de @this.passwordForm
   */
  get f() {
    return this.passwordForm.controls;
  }

  /**
   * Si el usuario esconde el modal, lo manda a su dashboard correspondiente
   * manteniendo como contraseña 123456, la cual le tocará cambiarla por medio del dashboard
   */
  hideModal() {
    this.modalRef.hide();

    this.router.navigate(['/dashboard']);
  }

  changePassword() {
    console.log(this.passwordForm.value);

    this._sended = true;

    this._login.changePasswordUserVerified(this.passwordForm.value).subscribe(
      (data) => {
        console.log(data);

        this._swal
          .showPromiseSuccessModal(
            'Contraseña modificada con éxito',
            'Su contraseña ha sido modificada exitosamente. Inicie sesión con su nueva contraseña.'
          )
          .then((result) => {
            console.log(result);
            if (result['value']) {
              this.hideModal();
              this._sended = false;
              localStorage.clear();
              sessionStorage.clear();
            }
          });
      },
      (error) => {
        console.log(error);

        this._sended = false;
      }
    );
  }
}

// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
